<template>
  <Layout>
    <TableView ref="edocSendSettingTable" slot="content" maxWidth="992px" hidePagination 
      :list="edocSendSettingList" :columns="edocSendSettingColumns" 
      @nextList="selectEdocSendSettingList()" @action="onActionEdocSendSetting">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search"></b-icon>
        <input class="form-control form-control-solid w-300px ps-11" :placeholder="$t('템플릿명, 템플릿키')" :title="$t('템플릿명, 템플릿키')"
          @change="listParams.searchKeyword = $event.target.value">
      </div>
    </TableView>
  </Layout>
</template>
<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import Multiselect from 'vue-multiselect'

export default {
  components: { Layout, TableView, Multiselect },
  data: () => ({
    edocSendSettingColumns: [
      {
        key: 'tmplNm', label: '템플릿명',
        renderer: (item) => {
          return `<div>${item.tmplNm}</div><div class="fs-8 text-gray-500">${item.tmplKey}</div>`;
        }
      },
      { key: 'enabled', label: '전송 활성화', element: { type: 'check', default: false } },
      { key: 'startDt', label: '전송 시작일', element: { type: 'date' } },      
      { key: 'lastReqDt', label: '최종 요청일', style: { textAlign: 'center' }, renderer: (r) => { return r.lastReqDt ? r.lastReqDt.f('datetime-local') : '-'; } },
      { key: 'targetCount', label: '전송 대상 건', defaultValue: 0, style: { textAlign: 'center' } },
      { key: 'requestCount', label: '전송 요청 건', defaultValue: 0, style: { textAlign: 'center' } },
      { key: 'completeCount', label: '전송 완료 건', defaultValue: 0, style: { textAlign: 'center' } },
    ],
    listParams: { searchKeyword: '' },
    edocSendSettingList: [],
  }),
  created() {},
  mounted() {
    this.selectEdocSendSettingList();
  },
  beforeDestroy() {},
  computed: {},
  watch: {
    listParams: {
      deep: true,
      handler: 'selectEdocSendSettingList'
    }
  },
  methods: {
    async selectEdocSendSettingList(reset) {
      if (reset != undefined) this.edocSendSettingList = [];
      const { list } = await this.$api('adm/edoc/settings/selectEdocSendSettingList', { ...this.listParams });
      this.edocSendSettingList.push(...list);
    },
    async onActionEdocSendSetting({ action, item, event }) {
      if(action == 'enabled') {
        let params = { tmplKey: item.tmplKey, enabled: event.target.checked };
        if(this.$isEmpty(item.startDt)) {
          params.startDt = this.$today();
        }
        await this.updateEdocSendSetting(params);
      } else if(action == 'startDt') {
        await this.updateEdocSendSetting({ tmplKey: item.tmplKey, startDt: event.target.value });
      }

    },
    async updateEdocSendSetting(params, oldItem) {
      const res = await this.$api('adm/edoc/settings/updateEdocSendSetting', params);
      this.$toast(res.msg, { variant: res.success ? 'success' : 'danger' });

      let newItem = null;
      if(res.success) { // 성공
        newItem = res.data;
      } else { // 실패
        newItem = oldItem;
      }
      this.$set(this.edocSendSettingList, this.edocSendSettingList.findIndex(item => item.tmplKey === params.tmplKey), newItem);
    },
  },
}
</script>
